// Phase 999.4 Plan 06 — Client-side ValueClass validator (R4 + D-14).
//
// Mirrors the server-side AdminValueClassParser (Library/AdminValueClassParser.cs)
// from Plan 02. JavaScript's Number() parsing is locale-invariant by definition,
// so this matches the InvariantCulture contract of the server-side parser without
// any explicit locale plumbing.
//
// Pitfall #2 (RESEARCH §Pitfalls): Number('') returns 0 (not NaN) — Integer/Number/
// Double MUST reject empty string explicitly via `value === ''` guard BEFORE calling
// Number(value). This is pinned by the test suite below.
//
// R4 acceptance: String accepts any value including empty (operator must be able
// to set ZOffsetEffectiveFrom to '' to clear the override).

export function validateByValueClass(value, valueClass) {
    switch (valueClass) {
        case 'Boolean': {
            const v = (value ?? '').toString().toLowerCase();
            if (v === 'true' || v === 'false') return { ok: true };
            return { ok: false, error: "Boolean must be 'true' or 'false'." };
        }
        case 'Integer': {
            if (value === '' || value == null) return { ok: false, error: 'Integer is required.' };
            const n = Number(value);
            if (!Number.isFinite(n) || !Number.isInteger(n)) return { ok: false, error: 'Integer must be a whole number.' };
            return { ok: true };
        }
        case 'Double':
        case 'Number': {
            if (value === '' || value == null) return { ok: false, error: `${valueClass} is required.` };
            const n = Number(value);
            if (!Number.isFinite(n)) return { ok: false, error: `${valueClass} must be a finite number.` };
            return { ok: true };
        }
        case 'String':
            // R4 acceptance: empty string is accepted (means "no-op" / clear override).
            return { ok: true };
        default:
            return { ok: false, error: `Unknown ValueClass '${valueClass}'.` };
    }
}

export default validateByValueClass;
